module.exports = __webpack_public_path__ + "images/liinilaevad/routes/pointers/KIH-PAR-KIH.png";